import { QueryFunction, useQuery } from "react-query";
import { AxiosError } from "axios";

import { fetchUserLocalProjects } from "../../api/projects";

import { IProject } from "modules/projects/types/entities";
import { UserLocalProjectsDto } from "modules/projects/types/dto";

export const USER_LOCAL_PROJECTS_QUERY_KEY = "/projects/user_local_projects";

type IUserLocalProjectsQueryKey = [string, UserLocalProjectsDto];

const queryFn: QueryFunction<IProject[], IUserLocalProjectsQueryKey> = ({
  queryKey: [, params]
}) => fetchUserLocalProjects(params);

export const useUserLocalProjectsQuery = (
  params: UserLocalProjectsDto = {}
) => {
  const queryResults = useQuery<
    IProject[],
    AxiosError,
    IProject[],
    IUserLocalProjectsQueryKey
  >([USER_LOCAL_PROJECTS_QUERY_KEY, params], {
    queryFn
  });

  return queryResults;
};
